module.exports = __webpack_public_path__ + "img/opportunities-json.abb84054.png";